import type { SliderProps } from "react-aria-components";
import { Label, Slider as AriaSlider, SliderThumb, SliderTrack } from "react-aria-components";
import cx from "classnames";

import Tooltip from "../Tooltip";
import styles from "./styles.module.css";

type SliderArgsProps<T> = SliderProps<T> & {
  label?: string;
  thumbLabels?: string[];
  maxLabel?: string;
  minLabel?: string;
  hasError?: boolean;
  tooltip?: boolean;
};

const Slider = <T extends number | number[]>({
  maxLabel,
  hasError,
  thumbLabels,
  minLabel,
  tooltip,
  ...props
}: SliderArgsProps<T>) => {
  return (
    <AriaSlider {...props} className={cx(styles.slider, hasError && styles.error)}>
      <SliderTrack className={styles.track}>
        {({ state }) =>
          state.values.map((_, i) => (
            <Tooltip
              mode="parent"
              active={!!tooltip}
              key={i}
              on={(props) => (
                <SliderThumb
                  key={i}
                  index={i}
                  aria-label={thumbLabels?.[i]}
                  className={styles.handle}
                  {...props}
                />
              )}
            >
              {state.getThumbValueLabel(i)}
            </Tooltip>
          ))
        }
      </SliderTrack>
      {minLabel && <Label className={styles.label}>{minLabel}</Label>}
      {maxLabel && <Label className={styles.label}>{maxLabel}</Label>}
    </AriaSlider>
  );
};

Slider.displayName = "DS.Slider";
export default Slider;
